module.exports = __webpack_public_path__ + "img/current_meds.8137e0cf.svg";